import axios from 'axios';
import { API_URL, API_URL_LOCAL, API_LOCAL } from "../constantes/constantes";

export async function getTeamCard({type, sport, idEvent}) {
  let apiURL= `${API_URL_LOCAL}${API_LOCAL}teamInformation.json`;
  // let apiURL= `../data/teamInformation.json`;
  console.log(`url == ${API_URL}${type}/${sport}/${idEvent}.json`);

  try {
    const { data, status } = await axios.get(apiURL, {
      timeout: 25000,
      headers: {
        'Accept': 'application/json, text/plain, */*'
      }
    });

    return { data, statusCode: status };
  } catch (error) {
    console.error("Error en getTeamCard:", error.message || error);
    const statusCode = error.response?.status || 500;
    return { statusCode, data: [] };
  }
}